import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { media } from 'core/layout';

export const StyledMap = styled.div`

  ${({width}) => width && css`
    width: ${width};
  `}; 

  ${({height}) => height && css`
    height: ${height};
  `}; 

  ${media.tabletSmall`
    width: 100%;
    height: 200px;
  `};

  > div {
    width:100%;
    height:100%;
    ${media.tabletSmall`
       margin-top: 2em;
    `};
  }
`;


// WEBPACK FOOTER //
// ./src/elements/GoogleMap/styled.js